/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SalesForOnePeriod
 */
export interface SalesForOnePeriod {
    /**
     * Start datetime of the period of sales.
     * @type {Date}
     * @memberof SalesForOnePeriod
     */
    fromDateTime: Date;
    /**
     * End datetime of the period of sales.
     * @type {Date}
     * @memberof SalesForOnePeriod
     */
    toDateTime: Date;
    /**
     * Total value of sales in the period.
     * @type {number}
     * @memberof SalesForOnePeriod
     */
    totalSaleValue: number;
}

/**
 * Check if a given object implements the SalesForOnePeriod interface.
 */
export function instanceOfSalesForOnePeriod(value: object): value is SalesForOnePeriod {
    if (!('fromDateTime' in value) || value['fromDateTime'] === undefined) return false;
    if (!('toDateTime' in value) || value['toDateTime'] === undefined) return false;
    if (!('totalSaleValue' in value) || value['totalSaleValue'] === undefined) return false;
    return true;
}

export function SalesForOnePeriodFromJSON(json: any): SalesForOnePeriod {
    return SalesForOnePeriodFromJSONTyped(json, false);
}

export function SalesForOnePeriodFromJSONTyped(json: any, ignoreDiscriminator: boolean): SalesForOnePeriod {
    if (json == null) {
        return json;
    }
    return {
        
        'fromDateTime': (new Date(json['fromDateTime'])),
        'toDateTime': (new Date(json['toDateTime'])),
        'totalSaleValue': json['totalSaleValue'],
    };
}

  export function SalesForOnePeriodToJSON(json: any): SalesForOnePeriod {
      return SalesForOnePeriodToJSONTyped(json, false);
  }

  export function SalesForOnePeriodToJSONTyped(value?: SalesForOnePeriod | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fromDateTime': ((value['fromDateTime']).toISOString()),
        'toDateTime': ((value['toDateTime']).toISOString()),
        'totalSaleValue': value['totalSaleValue'],
    };
}

